import { Component, Input, OnChanges } from '@angular/core';

@Component({
    selector: 'app-power-circle',
    templateUrl: './power-circle.component.html',
    styleUrls: ['./power-circle.component.scss'],
    standalone: false
})
export class PowerCircleComponent implements OnChanges {

  @Input() x: number;
  @Input() y: number;
  @Input() radius: number;
  @Input() colorScale: string;
  @Input() label : string;
  @Input() value: number;
  @Input() limit: number;
  @Input() icon?: string;


  strokeWidth = 4;
  progress = 0;
  dashOffset = 0;
  diameter = 0
  circumference = 0;
  progressColor = '#00ff00';
  displayValue = 0;
  top: number;
  left: number;
  width: number;
  height: number;
  iconSize = 24;

  ngOnChanges() {
    this.diameter = this.radius * 2;
    // this.circumference = 2 * Math.PI * (this.radius - this.strokeWidth);
    this.circumference = 2 * Math.PI * (this.radius);
    this.progress = Math.min(this.value / this.limit, 1);
    this.dashOffset = this.circumference * (1 - this.progress);
    // this.displayValue = Math.round((this.value / 10) / 10) / 10;
    this.displayValue = this.value
    // if (this.label === 'centro') console.log('icon del circle', this.icon);
    this.progressColor = this.getProgressColor(this.progress);

    this.top = (this.y - this.radius);
    this.left = (this.x - this.radius);
    this.width = (this.radius * 2);
    this.height = (this.radius * 2);
  }

  getProgressColor(progress: number): string {
    if (progress < 0.75) return 'rgb(0,255,0)';
    const r = Math.min(255, 255 * (progress - 0.75) / 0.25);
    const g = 255 - r;
    return `rgb(${r},${g},0)`;
  }

  get iconScale(): number {
    // return this.radius ? this.radius / 80 * 2 : 0.1;
    return 0.05
  }

}
